import { Component, QueryList, ViewChildren } from '@angular/core';
import { TABLANUEVOCOTIZACIONES, tablaNuevoCotizaciones } from '../../../../../shared/data/tables/tabla-nuevo-cotizaciones';
import { NgbdSortableHeader, SortEvent } from '../../../../../shared/directives/NgbdSortableHeader';
import { TableService } from '../../../../../shared/services/table-nuevo-cotizaciones';
import { Observable } from 'rxjs';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-nuevo-cotizaciones',
  templateUrl: './nuevo-cotizaciones.component.html',
  styleUrls: ['./nuevo-cotizaciones.component.scss']
})
export class NuevoCotizacionesComponent {

  // Dropdown data for various categories
  public Realizado = [
    { value: "1", label: "111 - JOSE JORGE ARRIETA", job: "Developer" },
    { value: "2", label: "2222 - DEIVER PORRAS", job: "Developer" },
    { value: "3", label: "33333 - JOSE JORGE", job: "Designer" },
  ];

  public Cliente = [
    { value: "1", label: "222222 - EMPRESA DE PRUEBAS", job: "Developer" },
    { value: "2", label: "555555 - EMPRESA DE PRUEBAS", job: "Developer" },
  ];

  public Tiposclientes = [
    { value: "1", label: "EMPRESARIAL", job: "Developer" },
    { value: "2", label: "ESCOLAR", job: "Developer" },
  ];

  public TiposVehiculos = [
    { value: "1", label: "AUTOMOVIL", job: "Developer" },
    { value: "2", label: "BUSETA", job: "Developer" },
  ];

  public Origen = [
    { value: "1", label: "SANTA MARTA", job: "Developer" },
    { value: "2", label: "MEDELLIN", job: "Developer" },
  ];

  public Destino = [
    { value: "1", label: "SANTA MARTA", job: "Developer" },
    { value: "2", label: "MEDELLIN", job: "Developer" },
  ];

  public Tipoviaje = [
    { value: "1", label: "IDA Y REGRESO", job: "Developer" },
    { value: "2", label: "SOLO IDA", job: "Developer" },
  ];

  // Selected values for forms
  public realizado: string;
  public cliente: string;
  public tiposclientes: string;
  public tiposvehiculos: string;
  public origen: string;
  public destino: string;
  public tipoviaje: string;

  // Variables for date range
  model: NgbDateStruct;
  date: { year: number; month: number };
  displayMonths = 2;
  navigation = "select";
  showWeekNumbers = false;
  outsideDays = "visible";
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  model2: NgbDateStruct;
  placement = "top";

  // Other variables
  public isCollapsed = true;
  public servicioAgregado: string = '';
  mostrarTabla: boolean = false;  // Toggle visibility of the table
  public selected = [];
  public searchText: string;

  // Table data and service
  public tableItem$: Observable<tablaNuevoCotizaciones[]>;
  public total$: Observable<number>;

  // Services options
  public servicios = [
    { value: "1", label: "Servicio 1", job: "Developer" },
    { value: "2", label: "Servicio 2", job: "Developer" },
    { value: "3", label: "Servicio 3", job: "Developer" },
  ];

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  // Constructor to initialize the component
  constructor(
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter, 
    private service: TableService
  ) {
    // Initialize table data and set user data
    this.tableItem$ = service.tableItem$;
    this.total$ = service.total$;
    this.service.setUserData(TABLANUEVOCOTIZACIONES); // Set the data for the table
    
    // Initialize date range
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), "d", 10);
  }

  ngOnInit() {}

  // Method to handle date selection
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  // Helper methods for date range logic
  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  // Validate the date input
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  // Method to toggle service list visibility
  agregarServicio() {
    this.mostrarTabla = !this.mostrarTabla;  // Toggle visibility of the table
  }

  // Sort method for the table
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  // Method to delete table data
  deleteData(id: number) {
    this.tableItem$.subscribe((data: any) => {
      data.map((elem: any, i: number) => {
        if (elem.id === id) {
          data.splice(i, 1);
        }
      });
    });
  }
}
